export default __webpack_public_path__ + "static/media/724.ce1062d8.gif";